import { useLocalSearchParams } from 'expo-router'

import { AdminWebViewScreen } from '@/src/features/admin/ui/AdminWebViewScreen'

export default function AdminScreen() {
  const { url } = useLocalSearchParams<{ url?: string | string[] }>()
  return <AdminWebViewScreen key={typeof url === 'string' ? url : ''} url={typeof url === 'string' ? url : ''} />
}
